import {gql} from 'graphql-request';
import {activityLogSubjects} from 'src/services/ActivityLog/ActivityLogTransform';
import {saasFragment} from '../shared/Fragments';

export const mfaDisabledFilter = `
  {_and: [
    {subject: {_eq: "MFA_CHANGE"}},
    {
      _and: [
        {subject: {_eq: "MFA_CHANGE"}},
        {new_value: {_neq: "true"}},
      ]
    }
  ]},
`;

// These values differ from userStatusStrings by case
// i.e. userStatusStrings are e.g. 'Enabled"
const driftUserStatusStrings = {
  enabled: 'enabled', // haven't actually shouldIncludeInternal this one
  deleted: 'deleted',
  disabled: 'disabled',
  noData: '-',
}

export const onBoardingFilter = `
  {
    _or: [
      {_and: [
        {_or: [
          {old_value: {_ilike: ${driftUserStatusStrings.deleted}}},
          {old_value: {_ilike: ${driftUserStatusStrings.disabled}}},
          {old_value: {_ilike: "-"}},
          {old_value: {_ilike: ""}}
        ]},
        {subject: {_eq: ${activityLogSubjects.statusChange}}}
      ]},
      {subject: {_eq: ${activityLogSubjects.newUser}}}
    ],
  },
`;
export const defaultFilter = `
      {subject: {_neq: ${activityLogSubjects.appStatusChange}}},
`

// Every drift type the activity log shows: all drifts except app status changes
export const allDriftsFilter =
  `{subject: {_in: [${[
    activityLogSubjects.userActivity,
    activityLogSubjects.mfaChange,
    activityLogSubjects.privilegeChange,
    activityLogSubjects.statusChange,
    activityLogSubjects.newUser,
    activityLogSubjects.federationStatusChange,
  ].join(',')}]}}`

export const offBoardingFilter = `
  {
    _and: [
      {old_value: {_ilike: ${driftUserStatusStrings.enabled}}},
      {subject: {_eq: ${activityLogSubjects.statusChange}}}
    ]
  },
`;

export const userActivityFilter = `
  {
    _and: [
      {subject: {_eq: ${activityLogSubjects.userActivity}}}
    ]
  },
`;

export const privilegeChangeFilter = `
  {subject: {_eq: ${activityLogSubjects.privilegeChange}}},
`;

export const federationStatusChangeFilter = `
  {subject: {_eq: ${activityLogSubjects.federationStatusChange}}},
`;

export const activityLogQuery = (
  filter: any
) => gql`
query ActivityLog (
  $startDate: timestamp,
  $saasIdentifier: String = "",
  $userPubIdBoolExp: generic_user_bool_exp,
  $clientBoolExp: client_bool_exp,
) {
  drift(
    where: {
      _and: [
        {drift_time: {_gte: $startDate}},
        {client_saas:{
          saas: {name: {_regex: $saasIdentifier}},
          client: $clientBoolExp
        }},
        {generic_user: $userPubIdBoolExp},
        ${filter}
      ]
    },
    #offset: 0, 
    #limit: 25000,
    order_by: {drift_time: desc}
  ) {
    pub_id
    client_saas {
        saas {
          ...Saas
        }
    }
    generic_user {
      name
      email
      pub_id
    }
    subject
    old_value
    new_value
    drift_time
    part
    # not found. why? drift_id
    #addendum
  }
}${saasFragment}`;

